import { render, staticRenderFns } from "./ClientProjectsEditContractorsListItem.vue?vue&type=template&id=2f500ffe&"
import script from "./ClientProjectsEditContractorsListItem.vue?vue&type=script&lang=js&"
export * from "./ClientProjectsEditContractorsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports